module.exports = __webpack_public_path__ + "img/tanfer.ec7e793f.png";